/**
 * Build one list of all files on a ticket for both requester and IT views.
 * Merges `ticket.attachments` with files nested on `messages[].attachments`
 * (deduped by id) so nothing is missing if either API shape differs.
 *
 * @param {object|null|undefined} ticket
 * @param {Array<{ attachments?: object[] }>|null|undefined} messages
 * @returns {Array<object & { displaySource: 'ticket' | 'comments' }>}
 */
export function mergeTicketAttachmentsForDisplay(ticket, messages) {
  const map = new Map();

  const upsert = (a, flags) => {
    if (!a || a.id == null) return;
    const prev = map.get(a.id);
    if (prev) {
      Object.assign(prev, flags);
      return;
    }
    map.set(a.id, { ...a, ...flags });
  };

  for (const a of ticket?.attachments || []) {
    const linkedToMessage =
      a.ticketingRequestMessageId != null && String(a.ticketingRequestMessageId).trim() !== '';
    upsert(a, { displaySource: linkedToMessage ? 'comments' : 'ticket' });
  }

  for (const msg of messages || []) {
    for (const a of msg.attachments || []) {
      upsert(a, { displaySource: 'comments', sourceMessageId: msg.id });
    }
  }

  return [...map.values()].sort(
    (x, y) => new Date(y.createdAt || 0) - new Date(x.createdAt || 0),
  );
}
